import { getOsInfo } from "../hooks/useDetectOS";

export const getShortcut = (shortuctsConfig, name) => {
  let shortcutStr = shortuctsConfig[name].keys
    .map((key) => {
      key = key.toLowerCase();

      if (key === 'hover' || key === 'click') {
        return;
      }

      if (!getOsInfo().isMac) return key;

      if (key === 'alt') {
        return 'option';
      }

      if (key === 'ctrl') {
        return 'command';
      }

      if (key === 'delete') {
        return 'backspace';
      }

      return key;
    })
    .filter(Boolean)
    .join('+')
    .toLocaleLowerCase();

  // https://app.clickup.com/t/3326989/DEV-12656
  // we duplicate shortcuts for combination with capslock
  shortcutStr = `${shortcutStr},capslock+${shortcutStr}`;

  return shortcutStr;
};

export const hotkeysFilter = (event) => {
  const target = event.target || event.srcElement;
  const { tagName, type } = target;
  let flag = true;
  // ignore: isContentEditable === 'true', <input> and <textarea> when readOnly state is false, <select>
  if (
    target.isContentEditable ||
    (
      (tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT') &&
      !target.readOnly &&
      type !== 'checkbox' && type !== 'range' && type !== 'button'
    )
  ) {
    flag = false;
  }
  return flag;
};